export default __webpack_public_path__ + "static/blog-image-3525fb028ab2e8396caff449ee0ae7bc.png";